require('./style.less');

var Marionette = require('marionette');

module.exports = Marionette.ItemView.extend({
    className: 'esPage',
    //Note: ensure no white-space in the template
    // ... look at better way to accomplish (eg if more content added)?
    template: require('./template'),
    ui: {
        'pageText':     '.esPageText',
        'pageNumber':   '.esPgNum'
    },
    onRender: function() {

        var m = this.model,
            pgLabelAction = this.options.pageLabelAction;

        this.$el
            .attr('data-page-num', m.get('pgNum') ) // still using for closest hit (?)
            .addClass( m.get('viewCssClass') );

        this.ui.pageNumber.unselectable();

        if ( pgLabelAction && m.get('pgViewType') === 'PAGE' )
            this._setUpPageAction(pgLabelAction);

    },
    // Note: only called if setUpPageAction provided as option to widget
    _setUpPageAction: function(pgLabelAction) {

        var m = this.model;

        if ( pgLabelAction.onClick ) {

            // Note: confirmed no more detached DOM nodes exist on destroy with this event handler
            // (should be turned off with jq remove on destroy)

            this.ui.pageNumber.on('click', function () {

                pgLabelAction.onClick.call( this, {
                    number: m.get('pgNum'),
                    id: m.get('pgId')
                } );

            });
        }

        if ( pgLabelAction.appearAsLink )
            this.ui.pageNumber.addClass('link');

        if ( pgLabelAction.title ) {

            var title = !_.isFunction( pgLabelAction.title )
                ? pgLabelAction.title
                : pgLabelAction.title.call( this.ui.pageNumber[0], m.get('pgNum'));

            this.ui.pageNumber.attr('title', title );

        }

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/content/pages/page/view.js
 ** module id = 541
 ** module chunks = 0
 **/